(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-grid-item"] && !Shopify.designMode) return;
  try {
    (() => {
    const elementName = 'libas-product-card-campaign-badge';

    if (
      !('customElements' in window) ||
      typeof Intl === 'undefined' ||
      typeof Intl.DateTimeFormat !== 'function' ||
      customElements.get(elementName)
    ) {
      return;
    }

    const timeZone = 'Asia/Kolkata';
    const istOffsetMilliseconds = 330 * 60 * 1000;
    const days = [
      'sunday',
      'monday',
      'tuesday',
      'wednesday',
      'thursday',
      'friday',
      'saturday',
    ];
    const weekdayIndexes = {
      Sun: 0,
      Mon: 1,
      Tue: 2,
      Wed: 3,
      Thu: 4,
      Fri: 5,
      Sat: 6,
    };

    let formatter;

    try {
      formatter = new Intl.DateTimeFormat('en-GB-u-hc-h23', {
        timeZone,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        weekday: 'short',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hourCycle: 'h23',
      });
    } catch (error) {
      return;
    }

    const getIstParts = (date) => {
      const values = {};

      formatter.formatToParts(date).forEach((part) => {
        if (part.type !== 'literal') {
          values[part.type] = part.value;
        }
      });

      const weekdayIndex = weekdayIndexes[values.weekday];

      if (weekdayIndex === undefined) {
        return null;
      }

      return {
        year: Number(values.year),
        month: Number(values.month),
        day: Number(values.day),
        weekdayIndex,
        minuteOfDay: Number(values.hour) * 60 + Number(values.minute),
      };
    };

    const parseTime = (value) => {
      const match = /^(?:[01]\d|2[0-3]):[0-5]\d$/.exec(value || '');

      if (!match) {
        return null;
      }

      const [hour, minute] = value.split(':').map(Number);
      return hour * 60 + minute;
    };

    const parseIstDateTime = (dateValue, timeValue) => {
      const dateMatch = /^(\d{4})-(\d{2})-(\d{2})$/.exec(dateValue || '');
      const minuteOfDay = parseTime(timeValue);

      if (!dateMatch || minuteOfDay === null) {
        return null;
      }

      const year = Number(dateMatch[1]);
      const month = Number(dateMatch[2]);
      const day = Number(dateMatch[3]);

      if (year < 2000 || year > 2999) {
        return null;
      }

      const hour = Math.floor(minuteOfDay / 60);
      const minute = minuteOfDay % 60;
      const timestamp = Date.UTC(year, month - 1, day, hour, minute) - istOffsetMilliseconds;
      const verified = getIstParts(new Date(timestamp));

      if (
        !verified ||
        verified.year !== year ||
        verified.month !== month ||
        verified.day !== day ||
        verified.minuteOfDay !== minuteOfDay
      ) {
        return null;
      }

      return timestamp;
    };

    const isWithinWindow = (minuteOfDay, start, end) => {
      if (start === null || end === null || start === end) {
        return false;
      }

      if (start < end) {
        return minuteOfDay >= start && minuteOfDay < end;
      }

      return minuteOfDay >= start || minuteOfDay < end;
    };

    const getWeeklyWindow = (element, day) => {
      if (element.dataset[`${day}Enabled`] !== 'true') {
        return null;
      }

      const start = parseTime(element.dataset[`${day}StartTime`]);
      const end = parseTime(element.dataset[`${day}EndTime`]);

      if (start === null || end === null || start === end) {
        return null;
      }

      return { start, end };
    };

    const isActive = (element, now) => {
      const mode = element.dataset.scheduleMode;

      if (mode === 'once') {
        const start = parseIstDateTime(
          element.dataset.onceStartDate,
          element.dataset.onceStartTime,
        );
        const end = parseIstDateTime(
          element.dataset.onceEndDate,
          element.dataset.onceEndTime,
        );

        return start !== null && end !== null && end > start && now.getTime() >= start && now.getTime() < end;
      }

      const current = getIstParts(now);

      if (!current) {
        return false;
      }

      if (mode === 'daily') {
        return isWithinWindow(
          current.minuteOfDay,
          parseTime(element.dataset.dailyStartTime),
          parseTime(element.dataset.dailyEndTime),
        );
      }

      if (mode !== 'weekly') {
        return false;
      }

      const currentWindow = getWeeklyWindow(element, days[current.weekdayIndex]);

      if (currentWindow) {
        if (
          currentWindow.start < currentWindow.end &&
          current.minuteOfDay >= currentWindow.start &&
          current.minuteOfDay < currentWindow.end
        ) {
          return true;
        }

        if (currentWindow.start > currentWindow.end && current.minuteOfDay >= currentWindow.start) {
          return true;
        }
      }

      const previousDayIndex = (current.weekdayIndex + 6) % 7;
      const previousWindow = getWeeklyWindow(element, days[previousDayIndex]);

      return Boolean(
        previousWindow &&
          previousWindow.start > previousWindow.end &&
          current.minuteOfDay < previousWindow.end,
      );
    };

    const elements = new Set();
    let timerId = null;

    const scheduleNextUpdate = () => {
      if (!elements.size) {
        timerId = null;
        return;
      }

      const delay = 60000 - (Date.now() % 60000) + 50;
      timerId = window.setTimeout(updateAll, delay);
    };

    const updateAll = () => {
      if (timerId !== null) {
        window.clearTimeout(timerId);
      }

      timerId = null;
      const now = new Date();

      elements.forEach((element) => element.updateSchedule(now));
      scheduleNextUpdate();
    };

    const scheduler = {
      add(element) {
        elements.add(element);
        element.updateSchedule(new Date());

        if (timerId === null) {
          scheduleNextUpdate();
        }
      },
      remove(element) {
        elements.delete(element);

        if (!elements.size && timerId !== null) {
          window.clearTimeout(timerId);
          timerId = null;
        }
      },
      refresh: updateAll,
    };

    class ProductCardCampaignBadge extends HTMLElement {
      connectedCallback() {
        scheduler.add(this);
      }

      disconnectedCallback() {
        scheduler.remove(this);
      }

      updateSchedule(now) {
        let active = false;

        try {
          active = isActive(this, now);
        } catch (error) {
          active = false;
        }

        this.toggleAttribute('hidden', !active);
        this.setAttribute('aria-hidden', active ? 'false' : 'true');
      }
    }

    customElements.define(elementName, ProductCardCampaignBadge);

    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) {
        scheduler.refresh();
      }
    });

    window.addEventListener('pageshow', scheduler.refresh);
  })();

  (() => {
    const globalKey = '__libasJudgeMeCardBadgeRefresh';
    const selector = '[data-libas-judgeme-card-badge][data-id][data-shop-domain]';
    const existing = window[globalKey];

    if (existing && typeof existing.scan === 'function') {
      existing.scan(document);
      return;
    }

    const queuedBadges = new Set();
    let flushTimer = null;

    const formatCollectionReviewLabel = (badge) => {
      if (
        !document.body.classList.contains('template-collection')
        || !(badge instanceof Element)
      ) {
        return;
      }

      const previewBadge = badge.querySelector('.jdgm-prev-badge[data-number-of-reviews]');
      const stars = previewBadge && previewBadge.querySelector('.jdgm-prev-badge__stars[data-score]');
      const reviewText = previewBadge && previewBadge.querySelector('.jdgm-prev-badge__text');
      const reviewCount = previewBadge && previewBadge.dataset.numberOfReviews;
      const rating = Number.parseFloat(
        (previewBadge && previewBadge.dataset.averageRating)
        || (stars && stars.dataset.score)
        || ''
      );

      if (stars && Number.isFinite(rating)) {
        const roundedRating = (
          Math.round((rating + Number.EPSILON) * 10) / 10
        ).toFixed(1);
        const ariaLabel = stars.getAttribute('aria-label');

        stars.dataset.score = roundedRating;

        if (ariaLabel) {
          stars.setAttribute(
            'aria-label',
            ariaLabel.replace(/^-?\d+(?:\.\d+)?/, roundedRating)
          );
        }
      }

      if (
        reviewText
        && /^\d+$/.test(reviewCount || '')
      ) {
        const reviewLabel = `(${reviewCount})`;
        if (reviewText.textContent !== reviewLabel) {
          reviewText.textContent = reviewLabel;
        }
      }
    };

    const queueBadge = (badge) => {
      if (!(badge instanceof Element) || !badge.matches(selector)) {
        return;
      }

      formatCollectionReviewLabel(badge);

      const state = badge.dataset.judgeMeCardRefreshState;

      if (state === 'queued' || state === 'pending' || state === 'done' || state === 'failed') {
        return;
      }

      badge.dataset.judgeMeCardRefreshState = 'queued';
      queuedBadges.add(badge);

      if (flushTimer === null) {
        flushTimer = window.setTimeout(flush, 50);
      }
    };

    const scan = (root) => {
      if (!root) {
        return;
      }

      if (root instanceof Element && root.matches(selector)) {
        queueBadge(root);
      }

      if (typeof root.querySelectorAll === 'function') {
        root.querySelectorAll(selector).forEach(queueBadge);
      }
    };

    const markFailed = (badges) => {
      badges.forEach((badge) => {
        if (badge.isConnected) {
          badge.dataset.judgeMeCardRefreshState = 'failed';
        }
      });
    };

    const requestBadges = (shopDomain, badges) => {
      const badgesByProductId = new Map();

      badges.forEach((badge) => {
        const productId = badge.dataset.id;

        if (!/^\d+$/.test(productId || '')) {
          badge.dataset.judgeMeCardRefreshState = 'failed';
          return;
        }

        if (!badgesByProductId.has(productId)) {
          badgesByProductId.set(productId, []);
        }

        badgesByProductId.get(productId).push(badge);
        badge.dataset.judgeMeCardRefreshState = 'pending';
      });

      const productIds = Array.from(badgesByProductId.keys());

      if (!productIds.length) {
        return;
      }

      const endpoint = 'https://cache.judge.me/widgets/shopify/'
        + encodeURIComponent(shopDomain)
        + '?preview_badge_product_ids='
        + encodeURIComponent(productIds.join(','));
      const request = new XMLHttpRequest();

      request.open('GET', endpoint, true);
      request.timeout = 5000;
      request.onload = () => {
        if (request.status < 200 || request.status >= 300) {
          markFailed(badges);
          return;
        }

        let data;

        try {
          data = JSON.parse(request.responseText);
        } catch (error) {
          markFailed(badges);
          return;
        }

        const previewBadges = data && data.preview_badges;

        badgesByProductId.forEach((matchingBadges, productId) => {
          const badgeHtml = previewBadges && previewBadges[productId];

          if (typeof badgeHtml !== 'string') {
            markFailed(matchingBadges);
            return;
          }

          matchingBadges.forEach((badge) => {
            if (!badge.isConnected) {
              return;
            }

            badge.innerHTML = badgeHtml;
            formatCollectionReviewLabel(badge);
            badge.classList.add('jdgm--done-setup');
            badge.dataset.judgeMeCardRefreshState = 'done';
          });
        });
      };
      request.onerror = () => markFailed(badges);
      request.ontimeout = () => markFailed(badges);
      request.send();
    };

    const flush = () => {
      flushTimer = null;
      const groups = new Map();

      queuedBadges.forEach((badge) => {
        queuedBadges.delete(badge);

        if (!badge.isConnected) {
          return;
        }

        const shopDomain = (badge.dataset.shopDomain || '').trim();

        if (!/^[a-z0-9.-]+$/i.test(shopDomain)) {
          badge.dataset.judgeMeCardRefreshState = 'failed';
          return;
        }

        if (!groups.has(shopDomain)) {
          groups.set(shopDomain, []);
        }

        groups.get(shopDomain).push(badge);
      });

      groups.forEach((badges, shopDomain) => {
        for (let index = 0; index < badges.length; index += 50) {
          requestBadges(shopDomain, badges.slice(index, index + 50));
        }
      });
    };

    const observer = new MutationObserver((records) => {
      records.forEach((record) => {
        const target = record.target.nodeType === Node.ELEMENT_NODE
          ? record.target
          : record.target.parentElement;
        formatCollectionReviewLabel(target instanceof Element ? target.closest(selector) : null);

        record.addedNodes.forEach((node) => {
          const element = node.nodeType === Node.ELEMENT_NODE ? node : node.parentElement;
          const badge = element instanceof Element ? element.closest(selector) : null;

          formatCollectionReviewLabel(badge);

          if (node.nodeType === Node.ELEMENT_NODE) {
            scan(node);
          }
        });
      });
    });

    const start = () => {
      scan(document);
      observer.observe(document.documentElement, { childList: true, characterData: true, subtree: true });
    };

    window[globalKey] = { scan };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
      start();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
